import { setWorkerUrl } from "maplibre-gl";

// maplibre-gl v6 ships ESM-only and locates its worker script via
// `new Worker(new URL("maplibre-gl-worker.mjs", import.meta.url))` inside its own
// pre-built module. CRA's webpack5 build does not statically detect/bundle that
// pattern when it originates from a pre-built node_modules file — no worker chunk is
// ever emitted, so in production the browser requests a worker URL that doesn't
// exist, Cloudflare Pages' SPA fallback returns index.html for it, and the map fails
// to initialize ("Unexpected token '<'" / "non-JavaScript MIME type" errors).
//
// Fix: `scripts/copy-maplibre-worker.js` (run via the `prestart`/`prebuild` npm
// lifecycle hooks) copies the exact worker file maplibre-gl ships into
// public/maplibre-gl-worker.mjs, a real static asset served at a fixed, root-relative
// path. Point maplibre-gl at it explicitly via its own documented `setWorkerUrl` API
// — must run before any `Map` is constructed.
setWorkerUrl(`${process.env.PUBLIC_URL || ""}/maplibre-gl-worker.mjs`);
